import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

interface UseMaintenanceFinancialReviewSimpleEntriesRejectProps {
  financialReviewEntryId: string | undefined
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceFinancialReviewSimpleEntriesReject = ({
  financialReviewEntryId,
  options,
}: UseMaintenanceFinancialReviewSimpleEntriesRejectProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['maintenanceFinancialReviewSimpleEntriesReject'],
    mutationFn: () => {
      return privateAxios.put(`/maintenance/financial_review/simple_entries/${financialReviewEntryId}/reject`)
    },
    ...options,
  })
}
